import React from "react";

//package import

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
} from "@mui/material";

//component

const DelModal = ({
  status,
  status2,
  open,
  handleClose,
  provinceDelHandler,
  usersModal,
  provinceDelHandler2,
  NodeViewDelHandler,
}) => {
  //hooks

  // render

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      // fullWidth={true}
      sx={{
        color: "gray",
        borderRadius: 2,
      }}
    >
      <DialogTitle>{}</DialogTitle>
      <DialogContent>
        {/* users_modal */}

        {usersModal !== "users_modal" ? (
          <DialogContentText sx={{ textAlign: "center" }}>
            Are you sure you want to {status ? " active " : " inactive "}
            {status ? "the Province ? " : "the Province ? "}
          </DialogContentText>
        ) : null}

        {usersModal === "users_modal" ? (
          <DialogContentText sx={{ textAlign: "center" }}>
            Are you sure you want to {status2 ? "active" : "inactive"}
            {status2 ? " the Province User ?" : " the Province User ?"}
          </DialogContentText>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ marginTop: 5, margin: "auto" }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          No
        </Button>

        <Button
          variant="contained"
          onClick={
            usersModal === "users_modal"
              ? provinceDelHandler2 || NodeViewDelHandler
              : provinceDelHandler
          }
          sx={{
            backgroundColor: "gray",
            borderRadius: 2,
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DelModal;
